export const getOrderModule = (defaultModule, orderModuleType) => {
	if (orderModuleType && orderModuleType === 'ONLINE_SHOP') {
		return orderModuleType
	} else {
		return defaultModule
	}
}
